import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45')
];

export const server_loads = [];

export const dictionary = {
		"/": [17],
		"/about": [34],
		"/(authenticated)/account": [18,[2,3]],
		"/(authenticated)/account/[tab]": [19,[2,3,4]],
		"/confirm": [35],
		"/(authenticated)/dashboard": [20,[2]],
		"/(authenticated)/experimental": [21,[2,5]],
		"/(authenticated)/experimental/agents": [22,[2,5,6]],
		"/(authenticated)/experimental/agents/[tab]": [23,[2,5,6]],
		"/(authenticated)/experimental/float": [24,[2,5]],
		"/(authenticated)/experimental/hewsync": [25,[2,5,7]],
		"/(authenticated)/experimental/queue": [26,[2,5,8]],
		"/features": [36],
		"/forgot-password": [37],
		"/iframe": [38],
		"/login-as": [40],
		"/login": [39],
		"/logout": [41],
		"/markdown-preview": [42],
		"/reset-password": [43],
		"/share": [44,[],[16]],
		"/signup": [45],
		"/(authenticated)/[organization=organization]": [27,[2,9]],
		"/(authenticated)/[organization=organization]/api": [28,[2,9,10]],
		"/(authenticated)/[organization=organization]/api/[kind]/[id]/[[tab]]": [29,[2,9,10,11,12]],
		"/(authenticated)/[organization=organization]/dashboard": [30,[2,9]],
		"/(authenticated)/[organization=organization]/project/[id]/[...page]": [31,[2,9,13]],
		"/(authenticated)/[organization=organization]/[slug=perms]": [32,[2,9,14]],
		"/(authenticated)/[organization=organization]/[slug=perms]/[id]/[[tab]]": [33,[2,9,14,15]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';